import { Component } from '@angular/core';
import { NgIf } from '@angular/common';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-rodape',
  standalone: true,
  imports: [NgIf],
  templateUrl: './rodape.component.html',
  styleUrl: './rodape.component.scss'
})
export class RodapeComponent {
  constructor(public featureFlagService: FeatureFlagService) {}
}
